import jQuery from 'jquery'

class NavOption {
    constructor(options) {
        let defaultOption = {
            isRequired: false,
            isSelected: false,
            icon: ''
        }
        let customOption = jQuery.extend(defaultOption, options);

        if (typeof (customOption.title) === 'undefined' || typeof (customOption.url) === 'undefined') {
            return {};
        }
        this.title = customOption.title;
        this.icon = customOption.icon;
        this.isRequired = customOption.isRequired;
        this.isSelected = customOption.isSelected;
        this.url = customOption.url;
    }


}
function createNav(options) {//title,url必给

    return new NavOption(options);//必须包含id,title,url
}

const homeOption = createNav({ title: "首页", url: '/', id: 0, isRequired: true, isSelected: true, icon: "fa fa-home" });
const state = {
    navList: [homeOption],
    currentNav: homeOption
};
const getters = {};
const mutations = {
    SET_NAV: (state, navList) => {
        state.navList = navList;
        window.sessionStorage.setItem('navList', JSON.stringify(navList));
    },
    INIT_NAV: (state) => {
        window.sessionStorage.removeItem('navList');
        window.sessionStorage.removeItem('currentNav')
        state.navList = [homeOption];
        state.currentNav = homeOption;

    },
    SWITCH_NAV: (state, id) => {
        state.navList.forEach((v, i) => {
            if (i != id) {
                v.isSelected = false;
            } else {
                v.isSelected = true;
                state.currentNav = v;

            }
        });
        window.sessionStorage.setItem('navList', JSON.stringify(state.navList));
        window.sessionStorage.setItem('currentNav', JSON.stringify(state.currentNav))
    },
    RELOAD_NAV: (state) => {
        if (window.sessionStorage.getItem('navList') === null) {
            window.sessionStorage.setItem('navList', JSON.stringify(state.navList));
        }
        else {
            state.navList = JSON.parse(window.sessionStorage.getItem('navList'))
        }
        if (window.sessionStorage.getItem('currentNav') === null) {
            window.sessionStorage.setItem('currentNav', JSON.stringify(state.currentNav))
        }
        else {
            state.currentNav = JSON.parse(window.sessionStorage.getItem('currentNav'))
        }
    }
};

const actions = {
    closeView({ commit, state }, url) {
        let currentNavList = state.navList, length = currentNavList.length;
        for (let i in currentNavList) {
            if (currentNavList[i].url === url) {
                currentNavList.splice(i, 1);//0 1 2
                commit("SET_NAV", currentNavList);
                if (i != length - 1) {
                    commit("SWITCH_NAV", i);
                } else {
                    commit("SWITCH_NAV", i - 1);
                }
                break;
            }
        }
        return false;
    },
    openView({ commit, state }, options) {
        if (typeof (options.url) === 'undefined' || options.title === null) {
            return false;
        }
        let currentNavList = state.navList;
        for (let i in currentNavList) {
            if (currentNavList[i].url === options.url) {
                commit("SWITCH_NAV", i);
                return;
            }
        }

        let navOption = createNav(options);
        if (Object.keys(navOption).length == 0) {
            return false;
        }
        currentNavList.push(navOption)
        commit("SET_NAV", currentNavList);
        commit("SWITCH_NAV", currentNavList.length - 1);
    },

}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
